module.exports = __webpack_public_path__ + "img/exit_icon.2031bbdc.svg";